module.exports = __webpack_public_path__ + "static/media/result-decreased.9f271ead.svg";